import { Component, OnInit, ɵConsole } from '@angular/core';
import { NgbDateStruct, NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { OmsServiceService } from '../services/oms-service.service';
import { Router, ActivatedRoute } from '@angular/router';
import { SharedService } from '../../../../tools/src/lib/shared/shared.service';
import { ConstantsService } from '../services/constants.service';
import { FormGroup, FormControl, FormsModule, Validators } from '@angular/forms';
//import * as data from './data.';
import { ReportDetailsComponent } from '../modal-popups/report-details/report-details.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from "ngx-spinner";
import { NgbDate, NgbCalendar, NgbDateParserFormatter, NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { configurton } from '../../assets/data/configuration';
//import { UploadReportComponent } from '../modal-popups/upload-report/upload-report.component';
import { TrackOrderComponent } from '../modal-popups/track-order/track-order.component';
import { PrintDocumentsComponent } from '../modal-popups/print-documents/print-documents.component';
import { DatePipe, JsonPipe } from '@angular/common';
import { environment } from '../../environments/environment';
import { SamplesSubmitedComponent } from '../modal-popups/samples-submited/samples-submited.component';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-escalations',
  templateUrl: './escalations.component.html',
  styleUrls: ['./escalations.component.scss']
})
export class EscalationsComponent implements OnInit {
  model: NgbDateStruct;
  bsRangeValue: Date[];
  maxDate = new Date();
  currentDate = new Date();
  page = 1;
  pageSize = 20;
  collectionSize = 0;
  datacount = 0;
  curDate = new Date();
  from: string = "";
  year: String = '';
  month: String = '';
  day: String = '';
  searchForm: FormGroup;
  //verifyOtp:any;
  index = 0;
  selectedFromDate: any;
  selectedToDate: any;
  isOtpSend: boolean = false;
  orderDetailsRes = [];
  orderRequest = {};
  orderRequestBySearch = {};
  searchFormRequest = {};
  role: string = "";
  configuraionData;
  href = "";
  isSelected: boolean = true;
  totalRecords: Number = 0;
  isOrderListDataExist: boolean = false;
  diagnosticCenterList = [];
  orderStatusList: [];
  selectList: [];
  tenantOrgInfo: any;
  isTrack: Boolean = false;
  fromDate: any;
  endDate: any;
  isAllOrderSearch: Boolean = false;
  tenantsList: any=[];
  OrgList: any=[];
  organizationsOfTenants: any;
  dynamicSpan: number;
  hoveredDate: NgbDate | null = null;
  // fromDate: NgbDate | null | any;
  toDate: NgbDate | null;
  selectDate:any;
  formattedFromDate: any;
  formattedToDate: any;
  selectedValue = 'scheduled_date'; 
  options = [
    { label: 'Scheduled Date', value: 'scheduled_date' },
    { label: 'Created Date', value: 'created_date' },
  ];
  businessOptions = [
    { label: 'Consultation', value: '1' },
    { label: 'Medicine', value: '2' },
    { label: 'Pathology', value: '3' },
    { label: 'Radiology', value: '4' },
  ];

  isPrintDocumentBtn: boolean = false;
  isSampleCollectionMemo: boolean = false;
  isSampleSubmissionMemo: boolean = false;
  isPendingBtn: boolean = false; 
  fileDownloadDisable :Boolean =true;
  isRefundbtn :Boolean = false;
  status :any;
  selectedStatusValue: string
  selectedItems: any[] = [];
  selectedOrderIds: any[] = [];
  isSameLab : boolean = false;
  isDifferentLab : boolean = false;
  showRTPCR: Boolean = false
  dynamicBusiness : any=[];

  constructor(
    private omsServiceService: OmsServiceService,
    private _router: Router,
    private sharedService: SharedService,
    private _activatedRoute: ActivatedRoute,
    private constantsService: ConstantsService,
    private modalService: NgbModal,
    private SpinnerService: NgxSpinnerService,
    private calendar: NgbCalendar,
    public formatter: NgbDateParserFormatter,
    private toastr: ToastrService
  ) {

    this.searchForm = new FormGroup({
      searchBy: new FormControl(),
      searchByValue: new FormControl(),
      startDate: new FormControl("", [Validators.required]),
      endDate: new FormControl("", [Validators.required]),
      diagnosticBranch: new FormControl(),
      status: new FormControl(),
      selectedTenant: new FormControl(),
      selectedOrg: new FormControl(),
      ordersType: new FormControl([""]),
      sortBy:new FormControl('scheduled_date'),
      businessId: new FormControl(),
      rtpcr: new FormControl(false),

    });
    this.currentDate=new Date()
    this.maxDate.setDate(this.maxDate.getDate() + 7);
    this.bsRangeValue = [this.currentDate, this.maxDate];
    this.fromDate = calendar.getToday();
    this.toDate = calendar.getNext(calendar.getToday(), 'd', 7);
    // this.currentDate=new Date()
    // this.maxDate.setDate(this.maxDate.getDate() + 7);
    // this.bsRangeValue = [this.currentDate, this.maxDate];

    console.log(`this.currentDate,this.maxDate`, this.currentDate,this.maxDate);
  }

  ngOnInit(): void {
  this.searchForm.get('status').valueChanges.subscribe((status:any)=>{
      if (status == "pending" || status == "reallocation" || status == "tobeassigned" || status == "completed" || status == "printdocuments") {
          this.showRTPCR = true
      } else  {
          this.showRTPCR = false
      }
  })
  this.selectedStatusValue = "allorders";
    this.omsServiceService.tenantOrgInfo$.subscribe(data => {
      console.log('tenats load for order', data)
      this.tenantOrgInfo = data
      if (!this.tenantOrgInfo) {
        this.dynamicSpan = 10
        this.tenantOrgInfo = [];
        console.log("tenantOrgInfo is empty")
      } else {
        this.dynamicSpan = 8
        console.log("tenantOrgInfo is loaded")
      }

      var uniqueTenants = [];
      var uniqueOrgs = [];

      this.tenantOrgInfo.forEach((element, i) => {
        if (!uniqueTenants[this.tenantOrgInfo[i].tenantCode]) {
          this.tenantsList.push(this.tenantOrgInfo[i]);
          uniqueTenants[this.tenantOrgInfo[i].tenantCode] = 1;
        }
        if (!uniqueOrgs[this.tenantOrgInfo[i].orgCode]) {
          this.OrgList.push(this.tenantOrgInfo[i]);
          uniqueOrgs[this.tenantOrgInfo[i].orgCode] = 1;
        }
      });

      this.isAllOrderSearch = false;
      this.isTrack = false;
      this.totalRecords = 0;
      this.isOrderListDataExist = false;
      // this.SpinnerService.show();
      if (window.localStorage.getItem('role') == "superadmin" || window.localStorage.getItem('role') == "admin") {
        this.isTrack = true;
      }
      this.configuraionData = configurton.filter(x => x.role == window.localStorage.getItem('role'));
      let selectedFromDate = new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" + new Date().getDate();
      let toDateValue = new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" + new Date().getDate();
      let selectedToDate = this.sharedService.getStringDate(new Date(toDateValue));

      this.sharedService.actionById.subscribe(val => {

        //console.log(val);
      });
      this.sharedService.sessionId.subscribe(val => {

        //  this.from = val;

      });
      this.sharedService.role.subscribe(val => {
        this.role = val;
      });
      this.sharedService.headerDataEsc.subscribe(val => {
        if (window.localStorage.getItem('role') != "" && window.localStorage.getItem('role') != undefined) {
          console.log(`getting default order status`,val)
          if(localStorage.getItem('userDataRoleBased') != undefined && JSON.parse(localStorage.getItem('userDataRoleBased')).tenant != undefined && JSON.parse(localStorage.getItem('userDataRoleBased')).tenant =='1000267'){
            
          }else{
            if(window.localStorage.getItem('searchFormValues') != "" && window.localStorage.getItem('searchFormValues') != undefined)
             {
              this.loadFormData();
             }
             else{
              this.getOrderData(val, 1, false, 11);
             }

          }
          if (window.localStorage.getItem('role') == "superadmin" || window.localStorage.getItem('role') == "admin") {
            if (val == "0" || val == "26" || val == "25") //opd_c
              this.isAllOrderSearch = true;
            if (val == "26") {
               this.orderStatusList = this.configuraionData[0].header_unconfirmed_status;
            }
            else {
              this.orderStatusList = this.configuraionData[0].header_escstatus;
            }

          }

        }

      });

    }
    );

    // debugger
    if(localStorage.getItem('userDataRoleBased') != undefined && JSON.parse(localStorage.getItem('userDataRoleBased')).tenant != undefined && JSON.parse(localStorage.getItem('userDataRoleBased')).tenant =='1000267'){
      this.tenantsList = [{
            "tenantCode": "1000267",
             "tenantName": "Healthy Recovery"
      }]

    }else{
      this.getTenatList()
    }
    this.getBusinessData();
    this.loadFormData();
    this.searchForm.valueChanges.subscribe((formValues) => {
      localStorage.setItem('searchFormValues', JSON.stringify(formValues));
    });
  }

  getBusinessData() {
    let businesses = {};
        businesses["action"] = 'OMS/api/operation.php/v1/fetchBusinesses',
        businesses["type"] = 'post';
        this.omsServiceService.fetchBusiness(businesses).subscribe(
        (res:any) => {
             this.dynamicBusiness = res['data'];
        })
             
  }

  onTenantSelect() {
    let selectedTenant = this.searchForm.get('selectedTenant').value;
    if (selectedTenant.length > 0) {
      this.getTenantOrgList(selectedTenant)
    }
    var results = this.OrgList.filter(function (entry) {
      if (selectedTenant && selectedTenant.indexOf(entry.tenantCode) >= 0) {
        return true;
      }
    });
    this.organizationsOfTenants = results;
  }

  onTenantdeSelect(item) {
    let chnagedOrgs = [];

    if (this.searchForm.get('selectedOrg').value) {
      this.searchForm.get('selectedOrg').value.forEach(i => {
        console.log(i, item)
        if (i != item.orgCode)
          chnagedOrgs.push(i)
      })

      this.searchForm.patchValue({ 'selectedOrg': chnagedOrgs });
      console.log(chnagedOrgs)

    }
  }

  resetTeantFilters() {
    this.searchForm.patchValue({ 'selectedTenant': [], 'selectedOrg': [] });
    this.organizationsOfTenants = []
  }

  onOrgSelect() {
    let selectedTenant = this.searchForm.get('selectedTenant').value;
    let selectedOrg = this.searchForm.get('selectedOrg').value;
  }

  getTenantNameBycode(tenantCode) {
    let name = this.tenantsList.find(item => { return item.tenantCode == tenantCode });
    return name?.tenantName ? name.tenantName : '';
  }

  getOrgNameByCode(orgCode) {
    let name = this.OrgList.find(item => { return item.orgCode == orgCode });
    return name?.orgName ? name.orgName : "";
  }

  getTenatList() {
    let tenantList = {};
    tenantList["action"] = 'OMS/api/operation.php/v1/get/list/tenants';
    tenantList["type"] = 'post';
    this.omsServiceService.getTenantList(tenantList).subscribe((res: any) => {
      console.log(`restenat`, res);
      if (res.status === 1) {
        this.tenantsList = res["data"]
        
      }
    })
  }

  getTenantOrgList(data) {
    console.log(`data`, data);
    const requestBody = {}
    requestBody['tenantCode'] = `${data.join(',')}`;
    requestBody['action'] = 'OMS/api/operation.php/v1/fetch/org/list/tenantcodes';
    requestBody['type'] = 'post';
    this.omsServiceService.getTenatOrganisationList(requestBody).subscribe((res) => {
      if (res.status === 1) {
        let resData = res['data']['dataObject']
        this.organizationsOfTenants = [...resData]
        console.log(`this.organizationsOfTenants`, this.organizationsOfTenants);
      }
    })
  }

  getOrderData(orderStatus, page = 1, pagination,type) {
    if (!pagination) {
      // this.searchForm.reset();
      let selectedFromDate = new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" + new Date().getDate();

      let toDateValue = new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" + new Date().getDate();
      let selectedToDate = this.sharedService.getStringDate(new Date(toDateValue));
      this.selectedDate(selectedFromDate, selectedToDate);
      this.selectedDate(selectedFromDate, selectedToDate);
    }

    this.isAllOrderSearch = false;
    if ((window.localStorage.getItem('role') == "superadmin" || window.localStorage.getItem('role') == "admin") && (orderStatus == "0" || orderStatus == 26)) {
      this.isAllOrderSearch = true;

    }
    this.totalRecords = 0;
    this.SpinnerService.show();
    this.isOrderListDataExist = false;
    this.orderRequest = this.prepareGetOrderDataRequest(orderStatus,type);
    this.orderDetailsRes = [];

    this.orderRequest['tenantCodes'] = [];
    this.orderRequest['orgCodes'] = [];

    if (this.searchForm.get('selectedTenant').value) {
      // if tenant org filters are used 
      this.orderRequest['tenantCodes'] = this.searchForm.get('selectedTenant').value;
      if (this.searchForm.get('selectedOrg').value)
        this.orderRequest['orgCodes'] = this.searchForm.get('selectedOrg').value;


    } else {
      // by default we need to pass all tenat and org codes      
      this.tenantsList.map(item => {
        this.orderRequest['tenantCodes'].push(item.tenantCode);
      });
      this.OrgList.map(item => {
        this.orderRequest['orgCodes'].push(item.orgCode);
      });
    }

    this.orderRequest['skipTenantValidation'] = 1;
    // this.orderRequest["extraFilters"]=["careparents"]

    if(this.searchForm.value.ordersType !=''){
      if(this.searchForm.value.ordersType == 'careparents'){
          this.orderRequest["extraFilters"]=["careparents"]
      }else if(this.searchForm.value.ordersType == 'packageChildsOnly') {
          this.orderRequest["extraFilters"]=["packageChildsOnly"]
      }
    }

    this.omsServiceService.getOrderDetails(this.orderRequest).subscribe(
      (res) => {
        this.SpinnerService.hide();
        if (res["status"] == 1) {
          this.orderDetailsRes = res["data"][0]["orderDetails"];
          if (res["data"][0]["countOrder"][0] != null) {

            this.datacount = res["data"][0]["countOrder"][0]["count"];
            this.totalRecords = this.datacount;
            if(type == 11){
              this.page=1
            }
            this.configuraionData = configurton.filter(x => x.role == this.role);
            this.SpinnerService.hide();
          } else {
            this.isOrderListDataExist = true;
            this.datacount = 0;
          }

        } else {
          this.SpinnerService.hide();
          this.datacount = 0;
        }

      }

    )
  }

  getOrderById(orderId,detailUrl) {
    if(this.status == undefined){
      this.status = 'allorders';
    }
    this.SpinnerService.hide();
    let sessionId;
    this.sharedService.sessionId.subscribe(val => {
      sessionId = val;
    });
    if(detailUrl == 'orders'){
        var url=this._router.createUrlTree(['/escalation-details/' + orderId + '/' + this.status])
    }else if(detailUrl == 'opd'){
        var url=this._router.createUrlTree(['/order-details/' + orderId ])
    }
    var myWindow = window.open(url.toString(),orderId)
    myWindow.focus();
  }


  pageChange(currentPage) {
    console.log(`currentPage`, currentPage);
    if (this.searchForm.get('status').value != 0 && this.searchForm.get('status').value != undefined) {
      let status = this.searchForm.get('status').value
      this.getOrderData(status, currentPage, true, 22);
    }else{
      console.log(`currentPage123`, currentPage);
      let selectedStatus;
      this.sharedService.headerSelectedEscStatus.subscribe(val => {
        selectedStatus = val;
      });
      this.getOrderData(selectedStatus, currentPage, true, 22);
    }
  }

  search(searchFormData, page = 1) {
    this.isPrintDocumentBtn = false;
    this.isSampleCollectionMemo = false;
    this.isSampleSubmissionMemo = false;
    this.isPendingBtn = false;     
    this.totalRecords = 0;
    this.isOrderListDataExist = false;
    this.orderDetailsRes = [];
    this.SpinnerService.show();
    this.searchFormRequest = {};
    let fromDate = this.currentDate
    let selectedStatus;
    this.sharedService.headerSelectedEscStatus.subscribe(val => {

      console.log("select status value=" + val);
      selectedStatus = val;

    });
    let selectedFromDate;
    let selectedToDate;
    if (fromDate != null && fromDate != undefined ) {
      let fromDateValue = fromDate.getFullYear() + "-" + (fromDate.getMonth() + 1) + "-" + fromDate.getDate();
      selectedFromDate = this.sharedService.getStringDate(new Date(fromDateValue));
    } else {

      let fromDateValue = new Date().getFullYear() + "-" + (new Date().getMonth() - 2) + "-" + new Date().getDate();

    }
    let toDate = this.maxDate;
    if (toDate != null && toDate != undefined ) {
      let toDateValue = toDate.getFullYear() + "-" + (toDate.getMonth() + 1) + "-" + toDate.getDate();
      selectedToDate = this.sharedService.getStringDate(new Date(toDateValue));
    } else {

      let toDateValue = new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" + new Date().getDate();
      ;

    }
    this.searchFormRequest["actionById"] = window.localStorage.getItem('actionById');
    this.searchFormRequest["dateFilter"] = this.constantsService.DATE_FILTER;
    this.searchFormRequest["action"] = this.constantsService.ORDER_LIST_METHOD;
    this.searchFormRequest["type"] = this.constantsService.METHOD_TYPE;
    let searchStatus: boolean = false;

    if (this.searchForm.get("searchByValue").value != null && this.searchForm.get("searchByValue").value != undefined) {
      if (this.searchForm.get("searchBy").value == "MRN") {
        this.searchFormRequest["mrn"] = this.searchForm.get("searchByValue").value;
      }
      else if (this.searchForm.get("searchBy").value == "Order ID") {
        this.searchFormRequest["order_id"] = this.searchForm.get("searchByValue").value;
      }
      else if (this.searchForm.get("searchBy").value == "Order Did") {
        this.searchFormRequest["order_did"] = this.searchForm.get("searchByValue").value;
      }

    } else {
      this.searchFormRequest["startDate"] = selectedFromDate;
      this.searchFormRequest["endDate"] = selectedToDate;
    }
    if(this.searchForm.get("sortBy").value != null && this.searchForm.get("sortBy").value != undefined){
      if (this.searchForm.get("sortBy").value == "Scheduled Date") {
        this.searchFormRequest["dateFilter"] = "scheduled_date";
      }
      else if (this.searchForm.get("sortBy").value == "Created Date") {
        this.searchFormRequest["dateFilter"] = "created_date";
      }
    }
    this.searchFormRequest['skipTenantValidation'] = 1;

      if (searchFormData.controls.status.value != 0 && searchFormData.controls.status.value != undefined) {
        this.status = searchFormData.controls.status.value;
        let rtpcr = searchFormData.controls.rtpcr.value;
        console.log(`search_status`, status)
        if (this.status == "unconfirmed") {
          this.searchFormRequest["orderStatus"] = [0, 25];
        }else if (this.status == "pending") {
          this.searchFormRequest["orderStatus"] = [0, 1, 2, 3, 4, 5, 7, 9, 102, 101, 16, 106];
          this.isPendingBtn = true;
          if(rtpcr){
            this.searchFormRequest["ordType"] = "rtpcr"
          }
        } else if (this.status == "reallocation") {
          this.searchFormRequest["orderStatus"] = [1, 2, 3, 4, 5, 7, 26];
          if(rtpcr){
            this.searchFormRequest["ordType"] = "rtpcr"
          }
        } else if (this.status == "tobeassigned") {
          this.searchFormRequest["orderStatus"] = [0, 9, 25, 902];
          if(rtpcr){
            this.searchFormRequest["ordType"] = "rtpcr"
          }
        } else if (this.status == "completed") {
          this.searchFormRequest["orderStatus"] = [6, 106];
          if(rtpcr){
            this.searchFormRequest["ordType"] = "rtpcr"
          }
        } else if (this.status == "printdocuments") {
          this.searchFormRequest["orderStatus"] = [2, 3, 4, 5, 6];
          if(rtpcr){
            this.searchFormRequest["ordType"] = "rtpcr"
          }
          this.isPrintDocumentBtn = true;
        } else if (this.status == "reports") {
          this.showRTPCR = false
          this.searchFormRequest["orderStatus"] = [103];
          this.searchFormRequest["extra"] = ["includeGmr"];
          this.searchFormRequest["isInternalCall"] = 1;
          this.searchFormRequest["businessId"] = ["3"];
        } else if (this.status == "samplecollection") {
          this.showRTPCR = false
          this.isSampleCollectionMemo = true;
          this.searchFormRequest["orderStatus"] = [101];
          this.searchFormRequest["isInternalCall"] = 1;
          this.searchFormRequest["businessId"] = ["3"];
        } else if (this.status == "samplesubmissions") {
          this.showRTPCR = false
          this.isSampleSubmissionMemo = true;
          this.searchFormRequest["orderStatus"] = [102];
          this.searchFormRequest["isInternalCall"] = 1;
          this.searchFormRequest["businessId"] = ["3"];
        } else if (this.status == "cancel") {
          this.showRTPCR = false
          this.searchFormRequest["orderStatus"] = [8];
          this.searchFormRequest["isInternalCall"] = 1;
        }
 
        if (window.localStorage.getItem('role') == "superadmin" && selectedStatus == 26 && this.status != 3) {
          this.searchFormRequest["orderStatus"] = [status];
        }
 
        if (window.localStorage.getItem('role') == "superadmin" && selectedStatus == 23 && this.status != 3) {
          this.searchFormRequest["orderStatus"] = [status];
        }
 
      } else {
 
        this.searchFormRequest["orderStatus"] = [0,1,2,3,4,5,6,7,8,9,15,25,26,102,103,104,105,101,16,106,505,1000,1001,902];
        this.isPendingBtn = true;
      }

console.log('getting order status 1='+this.searchFormRequest["orderStatus"])

    if (this.configuraionData[0].allowedStatus != undefined && this.configuraionData[0].allowedStatus.indexOf(-1) < 0) {
      if (selectedStatus == 0)
        this.searchFormRequest["orderStatus"] = this.configuraionData[0].allowedStatus;
      else
        this.searchFormRequest["orderStatus"] = [selectedStatus];

    }
console.log('getting order status 2='+this.searchFormRequest["orderStatus"])
  
console.log('getting order status 3='+this.searchFormRequest["orderStatus"])
    if (window.localStorage.getItem('role') == "26") {


      this.searchFormRequest["associateId"] = window.localStorage.getItem('associateId');
      this.searchFormRequest["associateBranchId"] = window.localStorage.getItem('branchId');
    } else if (window.localStorage.getItem('role') == "superadmin") {     
console.log('getting order status 4='+this.searchFormRequest["orderStatus"])  

    }

    if (this.pageSize != 0 && this.page != 0) {
      this.searchFormRequest["sortBy"] = this.constantsService.SORT_BY;
      this.searchFormRequest["limit"] = this.pageSize;
      this.searchFormRequest["skip"] = 0;
    }


    this.searchFormRequest['tenantCodes'] = [];
    this.searchFormRequest['orgCodes'] = [];

    if (this.searchForm.get('selectedTenant').value) {
      // if tenant org filters are used 
      this.searchFormRequest['tenantCodes'] = this.searchForm.get('selectedTenant').value;
      if (this.searchForm.get('selectedOrg').value)
        this.searchFormRequest['orgCodes'] = this.searchForm.get('selectedOrg').value;


    } else {
      this.tenantsList.map(item => {
        this.searchFormRequest['tenantCodes'].push(item.tenantCode);
      });
      this.OrgList.map(item => {
        this.searchFormRequest['orgCodes'].push(item.orgCode);
      });
    }

    if(this.searchForm.get("businessId").value != null && this.searchForm.get("businessId").value != undefined){    
        this.searchFormRequest["businessId"] = [this.searchForm.get("businessId").value];
    }
    console.log('tenant', this.searchFormRequest['tenantCodes'])
    console.log('org', this.searchFormRequest['orgCodes'])
    console.log('sortBy', this.searchForm.get("sortBy").value)
    console.log('businessId', this.searchForm.get("businessId").value)
    // this.searchFormRequest["extraFilters"]=["careparents"]
    if(this.searchForm.value.ordersType !=''){
      if(this.searchForm.value.ordersType == 'careparents'){
          this.searchFormRequest["extraFilters"]=["careparents"]
      }else if(this.searchForm.value.ordersType == 'packageChildsOnly') {
          this.searchFormRequest["extraFilters"]=["packageChildsOnly"]
      }
    }
    this.omsServiceService.getOrderDetails(this.searchFormRequest).subscribe(
      (res) => {
        this.orderDetailsRes = res["data"][0]["orderDetails"];
        this.searchFormRequest = {};
        if (res["data"][0]["countOrder"][0] != null) {
          this.datacount = res["data"][0]["countOrder"][0]["count"];
          this.totalRecords = this.datacount;
          this.page =1;
        } else {
          this.isOrderListDataExist = true;
          this.datacount = 0;
        }
        this.SpinnerService.hide();
      }

    )
    this.SpinnerService.hide();
  }

  gotoChildOrders(OrderId:any){
    if(OrderId.order.business.pc_order_id != undefined &&  OrderId.order.business.pc_order_id !==''){
      this._router.navigate(['ordersList/'+OrderId.order.business.pc_order_id],  {
        queryParams: { mrn:OrderId.order.patientinfo.mrn, serviceType:100 }
     })
    }else{
      this._router.navigate(['ordersList/'+OrderId._id],  {
        queryParams: { mrn:OrderId.order.patientinfo.mrn, serviceType:OrderId.order.patientinfo. service_type }
     })
    }
    
  }
  getDate(val: any) {

    let dateEntered = val.target.value;

  }
  verifyOtpRequestInfo(obj, id) {

    let otp = (<HTMLInputElement>document.getElementById('verifyOtp' + id)).value;

    let verifyOtpInfoRequest = {};
    verifyOtpInfoRequest["method"] = this.constantsService.OTP_VERIFY_METHOD;
    verifyOtpInfoRequest["type"] = this.constantsService.METHOD_TYPE;
    verifyOtpInfoRequest["mobile"] = obj.order.patientinfo.contact;
    verifyOtpInfoRequest["email"] = obj.order.patientinfo.email;
    verifyOtpInfoRequest["keyValue"] = "MHO00213";
    verifyOtpInfoRequest["keyType"] = "ISP";
    verifyOtpInfoRequest["sourceType"] = "Mobile-APP";
    verifyOtpInfoRequest["otp"] = otp;


    this.omsServiceService.sendOtp(verifyOtpInfoRequest).subscribe(
      (res) => {
        this.isOtpSend = true;
        if (res["status"] == 1) {
          this.confirmOrder(obj);
        }

      }
    )
  }
  confirmOrder(obj) {

    let orderConfirmationRequest = {};

    orderConfirmationRequest["order_id"] = [obj.order.patientinfo.order_id];
    orderConfirmationRequest["actionById"] = window.localStorage.getItem('actionById');
    orderConfirmationRequest["actionByName"] = "UAT Madinaguda";
    orderConfirmationRequest["source"] = "1";
    orderConfirmationRequest["reason"] = "";

    orderConfirmationRequest["role_id"] = this.constantsService.ROLE_ID;
    orderConfirmationRequest["status"] = 301;
    orderConfirmationRequest["type"] = "post";
    orderConfirmationRequest["action"] = "OMS/api/operation.php/v1/order/change/status";
    this.omsServiceService.orderConfirmation(orderConfirmationRequest).subscribe(
      (res) => {

      });

  }

  prepareGetOrderDataRequest(orderStatus,type) {
    this.orderRequest = {};
    this.orderRequest["actionById"] = window.localStorage.getItem('actionById');

    this.orderRequest["dateFilter"] = this.constantsService.DATE_FILTER;    
    this.orderRequest["action"] = this.constantsService.ORDER_LIST_METHOD;
    this.orderRequest["type"] = this.constantsService.METHOD_TYPE;

     if (this.pageSize != 0 && this.page != 0 && type == 22) {
      this.orderRequest["sortBy"] = this.constantsService.SORT_BY;
      this.orderRequest["limit"] = this.pageSize;
      this.orderRequest["skip"] = this.pageSize * (this.page - 1);
    }else{
      this.orderRequest["sortBy"] = this.constantsService.SORT_BY;
      this.orderRequest["limit"] = this.pageSize;
      this.orderRequest["skip"] = 0;
    }

      if (orderStatus == "unconfirmed") {
        this.orderRequest["orderStatus"] = [0, 25]       
      }else if (orderStatus == "pending") {
        this.orderRequest["orderStatus"] = [0,1,2,3,4,5,7,9,102,101,16,106];
        this.isPendingBtn = true;
      } else if (orderStatus == "reallocation") {
        this.orderRequest["orderStatus"] = [1,2,3,4,5,7,26];
      }else if(orderStatus == "tobeassigned"){
        this.orderRequest["orderStatus"] = [0,9,25,902];
      }else if(orderStatus == "completed"){
        this.orderRequest["orderStatus"] = [6,106];
      }else if(orderStatus == "printdocuments"){
        this.orderRequest["orderStatus"] = [2,3,4,5,6];
      }else if(orderStatus == "reports"){
        this.orderRequest["orderStatus"] = [3];
        this.orderRequest["extra"] = ["includeGmr"];
        this.orderRequest["isInternalCall"] = 1;
      }else if(orderStatus == "samplecollection"){
        this.orderRequest["orderStatus"] = [101];
        this.orderRequest["isInternalCall"] = 1;
      }else if(orderStatus == "samplesubmissions"){
        this.orderRequest["orderStatus"] = [102];
        this.orderRequest["isInternalCall"] = 1;
      }else if(orderStatus == "cancel"){
        this.orderRequest["orderStatus"] = [8];
        this.orderRequest["isInternalCall"] = 1;
      }
      // else {
      //   this.orderRequest["orderStatus"] = [0,1,2,3,4,5,6,7,8,9,15,25,26,102,103,104,105,101,16,106,505,1000,1001,902];
      // }
 

    if (window.localStorage.getItem('role') == "admin") {
      this.orderRequest["associateId"] = window.localStorage.getItem('associateId');
      this.orderRequest["associateBranchId"] = window.localStorage.getItem('branchId');
      //branchId

    } else if (window.localStorage.getItem('role') == "superadmin") {
      // this.orderRequest["corporateType"] = 'chopd'; //opd_c
    }
    if ((this.orderRequest["orderStatus"] == "" || this.orderRequest["orderStatus"] == undefined) && this.configuraionData[0].allowedStatus != undefined && this.configuraionData[0].allowedStatus.indexOf(-1) < 0) {
      this.orderRequest["orderStatus"] = this.configuraionData[0].allowedStatus;
    }
    if(this.searchForm.get("businessId").value != null && this.searchForm.get("businessId").value != undefined){
      this.orderRequest["businessId"] = [this.searchForm.get("businessId").value];
    }

  if (this.searchForm.get("searchByValue").value != null && this.searchForm.get("searchByValue").value != undefined) {
    // searchStatus = true;
    if (this.searchForm.get("searchBy").value == "MRN") {
      this.orderRequest["mrn"] = this.searchForm.get("searchByValue").value;
    }
    else if (this.searchForm.get("searchBy").value == "Order ID") {
      this.orderRequest["order_id"] = this.searchForm.get("searchByValue").value;
    }
    else if (this.searchForm.get("searchBy").value == "Order Did") {
      this.orderRequest["order_did"] = this.searchForm.get("searchByValue").value;
    }
  }else{
    let fromDateValue = new Date().getFullYear() + "-" + new Date().getMonth() + "-" + new Date().getDate();
    let fromDate = this.currentDate
    let selectedFromDate;
    if (fromDate != null && fromDate != undefined ) {
      let fromDateValue = fromDate.getFullYear() + "-" + (fromDate.getMonth() + 1) + "-" + fromDate.getDate();
      selectedFromDate = this.sharedService.getStringDate(new Date(fromDateValue));

    }

    this.orderRequest["startDate"] = selectedFromDate;
    let toDateValue = new Date().getFullYear() + "-" + (new Date().getMonth() + 2) + "-" + new Date().getDate();
    let selectedToDate;
    let toDate = this.maxDate;
    if (toDate != null && toDate != undefined ) {
      let toDateValue = toDate.getFullYear() + "-" + (toDate.getMonth() + 1) + "-" + toDate.getDate();
      selectedToDate = this.sharedService.getStringDate(new Date(toDateValue));
    }
    this.orderRequest["endDate"] = selectedToDate;

  }

    return this.orderRequest;

  }

  loadReports(order) {

    // //console.log("load");
    const modalRef = this.modalService.open(ReportDetailsComponent);
    modalRef.componentInstance.reportDocInfo = order;
    const closeModelRef = modalRef.result.then(
      (res) => {

        //this.getOrderDataById(this.id);

      }

    );
  }

  getDiagnostiCenterData() {

    let diagnosticCenterApi = {};
    diagnosticCenterApi["business_id"] = "3";
    diagnosticCenterApi["name"] = "test";
    diagnosticCenterApi["limit"] = 1000;
    diagnosticCenterApi["offset"] = 0;


    this.omsServiceService.getDiagnosticData(diagnosticCenterApi).subscribe(

      (res) => {
        if (res["status"] == "Success") {
          if (res["dataObject"] != null && res["dataObject"] != undefined) {
            for (let data of res["dataObject"]) {
              //console.log(data.code);
              //console.log(data.name);
              this.diagnosticCenterList.push({ "code": data.code, name: data.name });
            }
          }

        }
      }

    )
  }

  clear() {


    //this.searchByValue = "": 
    //console.log("clear");
    this.searchForm.reset();
    this.searchForm.patchValue({
      ordersType:""
    })
    this.currentDate=new Date()
    // this.maxDate.setDate(this.maxDate.getDate() + 7);
    // this.bsRangeValue = [this.currentDate, this.maxDate];
    // this.currentDate=new Date()
    this.maxDate.setDate(this.currentDate.getDate() + 7);
    this.bsRangeValue = [this.currentDate, this.maxDate];
    localStorage.removeItem('searchFormValues');
 

    // this.searchForm.

  }

  download(Id)
  {
    window.open(environment.invoiceDownload+Id,'_blank'); 
  }

  invoiceDownload(Id)
  {
    window.open(environment.prescriptionPrint+Id,'_blank');    
  }

  downloadSampleCollectionMemo(Id)
  {
    window.open(environment.sampleCollection+Id,'_blank');    
  }

  redirectPage(page){

    let sessionId;
    this.sharedService.sessionId.subscribe(val => {
      sessionId = val;
    });

if(page == 'refund'){

    var url=this._router.createUrlTree(['/escalations/' + page])

}else if(page == 'opd'){
    var url=this._router.createUrlTree(['/orders'])
}
    // const url=this._router.createUrlTree(['/opdexecution/' + '/escalations/' + page], { queryParams: { session: sessionId } })

    window.open(url.toString())
  }


  opentrackOrderModal(orderId) {
    //console.log(this.orderDetailsRes);
    const modalRef = this.modalService.open(TrackOrderComponent, { windowClass: 'commonStyleModals modalWidth90p' });
    const closeModelRef = modalRef.result.then(
      (res) => {

        //this.getOrderDataById(this.id);

      }

    );

    modalRef.componentInstance.order_id = orderId;


  }

  onValueChange(value: Date): void {
    var data = value;
    this.currentDate=data[0]
    this.maxDate=data[1]
    console.log(`data`, this.currentDate);
  }

  selectedDate(fromDate, endDate) {
    if (fromDate) {
      const [year, month, day] = fromDate.split('-');
      const obj = {
        year: parseInt(year), month: parseInt(month), day:
          parseInt(day.split(' ')[0].trim())
      };
      // this.fromDate = obj;
    }

    if (endDate) {
      const [year, month, day] = endDate.split('-');
      const obj = {
        year: parseInt(year), month: parseInt(month), day:
          parseInt(day.split(' ')[0].trim())
      };
      // this.endDate = obj;
    }
    this.searchForm.patchValue({ 'startDate': this.fromDate, 'endDate': this.endDate });
  }

  onDateSelection(date: NgbDate) {
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
    } else if (this.fromDate && !this.toDate && date && date.after(this.fromDate)) {
      this.toDate = date;
    } else {
      this.toDate = null;
      this.fromDate = date;
    }
  }

  isHovered(date: NgbDate) {
    return (
      this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate)
    );
  }

  isInside(date: NgbDate) {
    return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
  }

  isRange(date: NgbDate) {
    return (
      date.equals(this.fromDate) ||
      (this.toDate && date.equals(this.toDate)) ||
      this.isInside(date) ||
      this.isHovered(date)
    );
  }

  validateInput(currentValue: NgbDate | null, input: string): NgbDate | null {
    const parsed = this.formatter.parse(input);
    return parsed && this.calendar.isValid(NgbDate.from(parsed)) ? NgbDate.from(parsed) : currentValue;
  }

   openPrintDocumentModal(orderDetailsObj){
    const modalRef = this.modalService.open(PrintDocumentsComponent, { windowClass: 'commonStyleModals modalWidth60p' });
    const closeModelRef = modalRef.result.then(
      (res) => {
 
        // this.getOrderDataById(this.id);
 
      }
 
    );
 
    modalRef.componentInstance.orderObj = orderDetailsObj;
 
  }

selectAll() {
    this.selectedItems = this.selectedItems.length === this.orderDetailsRes.length ? [] : [...this.orderDetailsRes];
    console.log(`this.selectedItems`, this.selectedItems);
  }

  toggleSelection(item: any) {
 
    const index = this.selectedItems.indexOf(item);
    console.log(`index`, index);
    if (index === -1) {
      this.selectedItems.push(item);
    } else {
      this.selectedItems.splice(index, 1);
    }
      console.log(`this.selectedItems`, this.selectedItems);
 
  }

  sampleSubmission(){
    this.isSameLab = false;
    this.isDifferentLab = false;
    this.selectedOrderIds = [];
        // console.log(`this.selectedItems1`, this.selectedItems[0].order.provider_info[0].associate_id);
      this.selectedItems.forEach((data:any)=>{
    // console.log(`this.selectedItems2`, data.order.provider_info[0].associate_id);
        if(this.selectedItems[0].order.provider_info[0].associate_id == data.order.provider_info[0].associate_id){
          // this.toastr.success('selected same LAB');
            this.isSameLab = true;
            // this.selectedOrderIds.push(data._id);
            if (this.selectedOrderIds.indexOf(data._id) === -1) {
                this.selectedOrderIds.push(data._id);
            }
    console.log(`selectedOrderIds`, this.selectedOrderIds);
        }else{
          this.isDifferentLab = true;
          this.toastr.error('Please select orders from the same LAB');
        }
      })

      if((this.isSameLab) && (!this.isDifferentLab)){
         this.openSubmitSampleModal('samplesubmit',this.selectedOrderIds)
      }else{
          this.toastr.error('Please select orders from the same LAB');
      }
  }


 openSubmitSampleModal(status,Ids) {
    const modalRef = this.modalService.open(SamplesSubmitedComponent, { windowClass: 'commonStyleModals modalWidth50p'});
    const closeModelRef = modalRef.result.then(
      (res) => {
 
      });
 
    modalRef.componentInstance.isSendStatus = status;
    modalRef.componentInstance.order_id = Ids;
  }

  loadFormData(): void {
    const storedValues = localStorage.getItem('searchFormValues');
    if (storedValues) {
      const parsedValues = JSON.parse(storedValues);
      this.searchForm.patchValue(parsedValues);
      this.search(this.searchForm, 1);
    }
  }

  downloadInvoiceD(Id){
    window.open(environment.invoiceDownload+Id,'_blank'); 
  }
 
//   sampleSubmission() {
   
//     const firstId = this.selectedItems[0].order.provider_info[0].associate_id
//     if (this.selectedItems.every(obj => obj.order.provider_info[0].associate_id === firstId)) {
//       this.openSubmitSampleModal(status,1)
//       this.selectedItems=[]
//     } else {
//       this.toastr.error("Please select orders from the same LAB")
//       this.selectedItems=[]
//     }
//     console.log(`sampleSubmission`, firstId);
//   }

}
